<template>
  <CustomModal ref="modal" class="add-amendment-modal" title="Duppliquer un devis">
    <div>
      <CustomForm ref="form" :inputs=inputs :submit=buttons.submit>
        <div class="form-container">
          <div class="element">
            <CustomTextField class="title" :content=inputs.title />
            <div class="switch-container">
              <p>Copier le client</p>
              <CustomSwitchField :content=inputs.copyClient />
            </div>
            <div class="switch-container">
              <p>Copier les éléments généraux</p>
              <CustomSwitchField :content=inputs.copyGeneralElements />
            </div>
            <div class="switch-container">
              <p>Copier les préstations</p>
              <CustomSwitchField :content=inputs.copyServices />
            </div>
          </div>
        </div>
        <CustomButton class="submit-button" @click="submitForm" :params=buttons.submit style="margin-top: 15px"/>
      </CustomForm>
    </div>
  </CustomModal>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faXmark, faPlus, faUpLong, faCheck, faExclamation } from "@fortawesome/free-solid-svg-icons";
import CustomButton from "@/components/forms/customs/customButton/CustomButton.vue";
import CustomTextField from "@/components/forms/customs/customTextField/CustomTextField.vue";
import {NotificationService} from "@vues/v-common";
import {BusinessController} from "@/controllers/business/BusinessController";
import CustomForm from "@/components/forms/CustomForm.vue";
import CustomModal from "@/components/modals/CustomModal.vue";
import CustomSwitchField from "@/components/forms/customs/customSwitchField/CustomSwitchField.vue";
library.add(faXmark);
library.add(faPlus);
library.add(faCheck);
library.add(faUpLong);
library.add(faExclamation);

  export default {
      name: 'DuplicateBusinessModal',
      props: ['callback'],
      components: {CustomSwitchField, CustomModal, CustomForm, CustomTextField, CustomButton},
      data() {
          return {
            business: undefined,
            documentName: "test",
            inputs: {
              title: {label: 'Titre', value: '', type: 'text', required: true},
              copyClient: {
                value: true,
                left: { label: "", value: false},
                right: { label: "", value: true},
                lightMode: true
              },
              copyGeneralElements: {
                value: true,
                left: { label: "", value: false},
                right: { label: "", value: true},
                lightMode: true
              },
              copyServices: {
                value: true,
                left: { label: "", value: false},
                right: { label: "", value: true},
                lightMode: true
              },
            },
            buttons:{
              submit: {text: "Dupliquer"}
            },
            isTerminateButtonDisplayed: false
          };
      },
      methods: {
        async openModal(business) {
          this.$refs.modal.openModal();
          this.$refs.form?.startLoading();
          this.business = business;
          this.buttons.submit.disabled = false;
          this.inputs.title.value = "Copie - " + business.title;
          this.$refs.form?.stopLoading();
        },
        closeModal() {
          this.$refs.modal?.closeModal();
        },
        terminate(){
          this.closeModal();
          this.callback();
        },
        async submitForm() {
          const res = await this.$refs.form.submitForm(() => BusinessController.postDuplicateBusiness({
            title : this.inputs.title.value,
            copyClient : this.inputs.copyClient.value,
            copyGeneralElements : this.inputs.copyGeneralElements.value,
            copyServices : this.inputs.copyServices.value,
          }, this.business.id));
          if (!res.errors) {
            (new NotificationService).addNotification("success", "Contrat duppliqué");
            this.terminate();
          }
        }
      }
  }

</script>

<style lang="stylus" scoped>
    @require '~/src/common/style/common.styl';

    .form-container
      display flex
      flex-direction column

    .submit-button
      margin 20px auto auto

    @media only screen and (min-width: DESKTOP_SIZE)
      .form-container
        flex-direction row
        .element
          width: calc(100% - 4em)
          padding 2em

      .submit-button
        width 250px

   .switch-container
      display flex
      justify-content space-between
</style>

<style lang="stylus">
  .add-amendment-modal .modal
    width 500px !important
</style>